/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import TextInput from '../../common/TextInput';
import Button from '../../common/Button';
import {Link} from 'react-router';
import * as PathConstants from '../../../constants/pathConstants';
import * as userCreationText from '../../../constants/userCreationText';
import * as googleCaptcha from '../../../constants/googleCaptcha';
const Recaptcha = require('react-gcaptcha');

const UserForm = ({
  form,
  onSubmit,
  onChange,
  onBlur,
  reCaptchaCallback,
  errors,
  submitStatus,
  pageNumber,
  emailConfirmation,
  pageActive
}) => {
  let questions = [];
  if (form.formQuestions) {
    form
      .formQuestions
      .forEach(question => {
        let questionParts = [];
        question
          .questionParts
          .map(questionPart => {
            let className = "",
              divClassName = "";
            if (questionPart.questionPartName == "emailConfirmation" && emailConfirmation &&
               emailConfirmation !== "") {
              className = "email-confirmation-verified";
              divClassName = "email-confirmation-verified-div";
            }
            questionParts.push(
              <div
                className={"question-part col-xs-12 col-sm-9 " + divClassName}
                key={questionPart.questionPartName}>
                <TextInput
                  type="text"
                  onChange={onChange}
                  placeHolder={questionPart.questionPartLabel}
                  label={questionPart.questionPartLabel}
                  name={questionPart.questionPartName}
                  className={"userCreation-text-input " + className}
                  fieldClass={questionPart.questionPartName}
                  contextHelp={questionPart.questionPartContextHelp}
                  error={errors[questionPart.questionPartName]}
                  tooltip={questionPart.questionPartTooltipHelp}
                  required={questionPart.questionPartRequired == "1"}
                  onBlur={onBlur}/>
              </div>
            );
          });
        questions.push(
          <span className="question" key={question.questionID || question.questionName}>
            {question.questionGroupHelpText && <div
              dangerouslySetInnerHTML={{
              __html: question.questionGroupHelpText
            }}/>}
            <div className="row">
              {questionParts}
            </div>
          </span>
        );
      });
  }
  return (
    <div hidden={pageActive != pageNumber}>
      <div className="panel" id="user-panel">
        <div>
          <h2>
            Step 1 of 3: Account Details
          </h2>
          <div
            className="form-instructions"
            dangerouslySetInnerHTML={{
            __html: form.formPageHelp
          }}/>
        </div>
        <div className="row">
          <div className="required-info col-xs-12 col-sm-9">
            <span className="required-asterisk">*</span>
            <strong>
              Required Fields</strong>
          </div>
          <form className="col-xs-12 col-sm-9">
            <div className="mobile-border-container">
              {questions}
              <Recaptcha sitekey={googleCaptcha.key} verifyCallback={reCaptchaCallback}/>

              <div className="create-account-btns">
                <div id="submit-account" className="btn-container pull-right">
                  <Button
                    className="submit-account"
                    value={userCreationText.accountContinueButtonText}
                    onClick={onSubmit}
                    disabled={!submitStatus}/>
                </div>
                <div id="cancel-account" className="btn-container pull-right">
                  <Link to={PathConstants.pathToLogin}>
                    Cancel
                  </Link>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

UserForm.propTypes = {
  form: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  reCaptchaCallback: PropTypes.func.isRequired,
  submitStatus: PropTypes.bool.isRequired,
  pageNumber: PropTypes.number.isRequired,
  pageActive: PropTypes.number.isRequired,
  emailConfirmation: PropTypes.string,
  errors: PropTypes.object
};

export default UserForm;



/** WEBPACK FOOTER **
 ** ./src/components/account/createAccount/UserForm.js
 **/